var exports = {
  "kL": "xfd349460--a90404--container" + " " + __webpack_require__(27451)["T"],
  "nM": "xfd349460--a90404--row",
  "Kk": "xfd349460--a90404--icon",
  "Qq": "xfd349460--a90404--text",
  "nf": "xfd349460--a90404--link",
};

module.exports = exports;
